import React, { useContext, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { MappingsContext } from "../context/mappingsContext";

import {
  Input,
  Tabs,
  TabsPanel,
  Button,
  IconSettings,
} from "@salesforce/design-system-react";

import ObjectSelect from "../components/ObjectSelect";
import ExpandableSectionList from "../components/ExpandableSectionList";

function Mappings() {
  const { objectId } = useParams();

  const {
    setPluginObjectId,
    pluginObjectName,
    setPluginObjectName,
    changePluginObjectName,
  } = useContext(MappingsContext);

  useEffect(() => {
    setPluginObjectId(objectId);
  }, []);

  const handleChange = (event) => {
    console.log("HANDLE CHANGE");
    console.log(event.target.value);
    setPluginObjectName(event.target.value);
    changePluginObjectName(event.target.value);
  };

  return (
    <IconSettings iconPath="/icons">
      <Tabs id="tabs">
        <TabsPanel label="Mapping Settings">
          <Input
            label="Name"
            value={pluginObjectName}
            onChange={(event) => handleChange(event)}
          />
          <ObjectSelect pluginObjectId={objectId} />
          <ExpandableSectionList />
          <footer className="slds-modal__footer">
            <Link to="/settings">
              <Button label="Save" />
            </Link>
            <Link to="/settings">
              <Button label="Cancel" />
            </Link>
          </footer>
        </TabsPanel>
      </Tabs>
    </IconSettings>
  );
}

export default Mappings;
